<template>
  <div :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications
      transition-name="notification-list"
      transition-mode="out-in"
    />
    <router-view name="header" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <router-view name="footer" />
  </div>
</template>

<script>
// Loading some plugin css asynchronously
import('sweetalert2/dist/sweetalert2.css');
import('vue-notifyjs/themes/default.css');
export default {};
</script>

<style lang="scss">
.el-table .cell {
  word-break: normal !important;
}
</style>
